<template>
  <div
    id="Procesos"
    v-if="$store.state.global_privilegio_admin_registro_proceso.ver">
    <AdminMenu />
    <div class="row justify-content-md-center align-items-center">
      <div class="col-md-10">
        <div class="row container_admin">
          <!-- LISTA DE PROCESOS -->
          <div class="col-6 text-left mt-2">
            <b class="titulo">Procesos</b>
          </div>
          <div class="col-6 d-flex justify-content-end mt-3">
            <button
              v-show="
                $store.state.global_privilegio_admin_registro_proceso.crear
              "
              type="button"
              class="btn boton_guardar1"
              data-toggle="modal"
              data-target="#agregarproceso"
              style="margin-right: 2%; width: 260px !important"
            >
              <img
                src="img/iconos/registrar_proceso.png"
                alt="logo-color"
                class="icono mr-2"
              />Registrar nuevo proceso
            </button>
          </div>
          <div class="col-12 table mt-3">
            <v-client-table
              class="col-md-12 mt-3"
              :columns="columns_proceso"
              :data="informacion_proceso"
              :options="options_proceso"
            >
              <div slot="proceso" slot-scope="props" class="text-left">
                {{ props.row.proceso }}
              </div>
              <div slot="opciones" slot-scope="props">
                <center>
                  <button
                    class="btn dropdown-toggle boton_12"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <ul class="dropdown-menu b-dropdown-opt" role="menu">
                      <center>
                        <li>
                          <a
                            class="btn btn-block mi_boton"
                            @click="consultar_proceso(props.row.id)"
                            v-show="
                              $store.state
                                .global_privilegio_admin_registro_proceso.editar
                            "
                            >&nbsp;<b>Editar</b></a
                          >
                        </li>
                      </center>
                      <center>
                        <li>
                          <a
                            class="btn btn-block mi_boton"
                            @click="eliminar_proceso(props.row.id)"
                            v-show="
                              $store.state
                                .global_privilegio_admin_registro_proceso.eliminar
                            "
                            >&nbsp;<b>Eliminar</b>
                          </a>
                        </li>
                      </center>
                    </ul>
                  </button>
                </center>
              </div>
            </v-client-table>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL AGREGAR PROCESO -->
    <div
      class="modal fade"
      id="agregarproceso"
      data-backdrop="static"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content container_admin">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <div class="col-md-10">
              <label class="dato ml-3"><b>Nuevo Proceso</b></label> <br />
            </div>
            <div class="box-body row">
              <div class="col-md-2"></div>
              <div class="col-md-8 mt-4">
                <form v-on:submit.prevent="agregar_proceso()">
                  <textarea
                    v-model.trim.lazy="proceso"
                    class="form-control boton_texto"
                    placeholder="Nuevo proceso"
                  ></textarea
                  ><br />
                  <center>
                    <button
                      type="submit"
                      class="btn boton_guardar1"
                      style="width: 220px !important"
                    >
                      Guardar
                    </button>
                  </center>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL EDITAR PROCESO -->
    <div
      class="modal fade"
      id="editarproceso"
      data-backdrop="static"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content container_admin">
          <div class="modal-body">
            <div class="col-md-10">
              <label class="dato ml-3"><b>Editar Proceso</b></label> <br />
            </div>
            <div class="box-body row">
              <div class="col-md-2"></div>
              <div class="col-md-8 mt-4">
                <textarea
                  v-model.trim.lazy="con_proceso"
                  class="form-control boton_texto"
                  placeholder="Nuevo proceso"
                ></textarea
                ><br />
                <center>
                  <button
                    type="submit"
                    class="btn boton_guardar1 mr-3"
                    style="width: 200px !important"
                    @click="editar_proceso(con_key)"
                  >
                    Guardar
                  </button>
                  <button
                    type="submit"
                    class="btn boton_cancelar"
                    @click="vaciar_variables_proceso"
                  >
                    Cancelar
                  </button>
                </center>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- NO TIENE PERMISO PARA VER EL MÓDULO -->
  <div class="alert alert-warning" role="alert" v-else>
    No tiene permiso para vel el Módulo
  </div>
</template>

<script>
// IMPORTACION DE FIREBASE
import { firebase, auth, db } from "../../firebase";
// IMPORTACIÓN DE SWEET ALERT
import Swal from "sweetalert2";
import AdminMenu from "@/components/AdminMenu.vue";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

export default {
  name: "Procesos",
  components: {
    AdminMenu,
  },
  data() {
    return {
      // VARIABLES REGISTRO PROCESO
      proceso: "",
      fecha: "",
      hora_actual: "",

      // VARIABLES REGISTRO ZONA
      zona: "",

      // VARIABLES REGISTRO ACTIVIDAD
      mostrar_actividad: [],
      actividades_id: "",
      actividad: "",
      id_actividad: "",

      // VARIABLES REGISTRO TAREAS
      tareas: "",

      // VARIABLE CONSULTA PROCESO
      con_key: "",
      con_proceso: "",
      p_fecha_registro: "",
      p_hora_registro: "",
      con_registrado: "",

      // VARIABLE CONSULTAR ZONA
      con_key: "",
      con_zona: "",
      con_fecha: "",
      con_hora: "",
      con_registrado: "",

      // VARIABLE CONSULTAR ACTIVIDAD
      con_key: "",
      con_actividad: "",
      con_registrado: "",

      // VARIABLE CONSULTAR TAREA
      con_key: "",
      con_tareas: "",
      con_acti: "",
      c_acti: "",
      mostrar_id_acti: [],
      con_registrado: "",

      // VARIABLES PARA LA TABLA PROCESOS
      informacion_proceso: [],
      columns_proceso: ["proceso", "registrado_por", "opciones"],
      options_proceso: {
        headings: {
          proceso: "Procesos",
          registrado_por: "Registrado",
          opciones: "Opciones",
        },
        sortable: ["proceso", "registrado_por"],
        texts: {
          filter: "Buscar",
          filterPlaceholder: "",
        },
      },
    };
  },
  created() {
    if (
      this.$store.state.global_privilegio_admin_registro_proceso.ver == true
    ) {
      this.tabla_proceso();
    }

    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    today = dd + "/" + mm + "/" + yyyy;
    this.peligros();
  },
  methods: {
    async peligros() {
      let accidente = [];
      // console.log("total peligros");
      db.collection("matriz_riesgo")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            accidente.push(doc.data().em_clasificacion);
            // console.log(accidente);
          });
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },
    // TABLA DE PROCESOS
    tabla_proceso() {
      if (this.informacion_proceso.length > 0) {
      } else {
        this.informacion_proceso = [];
        db.collection("nuevo_proceso")
          .orderBy("p_fecha_registro", "desc")
          .onSnapshot((snapshot) => {
            let changes = snapshot.docChanges();
            changes.forEach((change) => {
              if (change.type === "added") {
                this.informacion_proceso.unshift({
                  id: `${change.doc.id}`,
                  proceso: `${change.doc.data().p_nuevo_proceso}`,
                  registrado_por: `${change.doc.data().p_registrado_por}`,
                });
              } else if (change.type === "modified") {
                for (
                  let index = 0;
                  index < this.informacion_proceso.length;
                  index++
                ) {
                  if (change.doc.id == this.informacion_proceso[index].id) {
                    this.informacion_proceso.splice(index, 1);
                  }
                }
                this.informacion_proceso.unshift({
                  id: `${change.doc.id}`,
                  proceso: `${change.doc.data().p_nuevo_proceso}`,
                  registrado_por: `${change.doc.data().p_registrado_por}`,
                });
              } else if (change.type === "removed") {
                for (
                  let index = 0;
                  index < this.informacion_proceso.length;
                  index++
                ) {
                  if (change.doc.id == this.informacion_proceso[index].id) {
                    this.informacion_proceso.splice(index, 1);
                  }
                }
              } else {
              }
              // DEVOLVER SOLO DATOS ÚNICOS, NO REPETIDOS
              let set = new Set(this.informacion_proceso.map(JSON.stringify));
              this.informacion_proceso = Array.from(set).map(JSON.parse);
            });
          });
      }
    },

    // TABLA ZONA
    tabla_zona() {
      if (this.informacion_zona.length > 0) {
      } else {
        this.informacion_zona = [];
        db.collection("nuevo_zona")
          .orderBy("z_fecha_registro", "desc")
          .onSnapshot((snapshot) => {
            let changes = snapshot.docChanges();
            changes.forEach((change) => {
              if (change.type === "added") {
                this.informacion_zona.unshift({
                  id: `${change.doc.id}`,
                  zona: `${change.doc.data().z_nuevo_zona}`,
                  registrado_por: `${change.doc.data().z_registrado_por}`,
                });
              } else if (change.type === "modified") {
                for (
                  let index = 0;
                  index < this.informacion_zona.length;
                  index++
                ) {
                  if (change.doc.id == this.informacion_zona[index].id) {
                    this.informacion_zona.splice(index, 1);
                  }
                }
                this.informacion_zona.unshift({
                  id: `${change.doc.id}`,
                  zona: `${change.doc.data().z_nuevo_zona}`,
                  registrado_por: `${change.doc.data().z_registrado_por}`,
                });
              } else if (change.type === "removed") {
                for (
                  let index = 0;
                  index < this.informacion_zona.length;
                  index++
                ) {
                  if (change.doc.id == this.informacion_zona[index].id) {
                    this.informacion_zona.splice(index, 1);
                  }
                }
              } else {
              }
              // DEVOLVER SOLO DATOS ÚNICOS, NO REPETIDOS
              let set = new Set(this.informacion_zona.map(JSON.stringify));
              this.informacion_zona = Array.from(set).map(JSON.parse);
            });
          });
      }
    },

    // TABLA ACTIVIDAD
    tabla_actividad() {
      if (this.informacion_actividad.length > 0) {
      } else {
        this.informacion_actividad = [];
        db.collection("nuevo_actividad")
          .orderBy("a_fecha_registro", "desc")
          .onSnapshot((snapshot) => {
            let change = snapshot.docChanges();
            change.forEach((change) => {
              if (change.type === "added") {
                this.informacion_actividad.unshift({
                  id: `${change.doc.id}`,
                  actividad: `${change.doc.data().a_nuevo_actividad}`,
                  registrado_por: `${change.doc.data().a_registrado_por}`,
                });
              } else if (change.type === "modified") {
                for (
                  let index = 0;
                  index < this.informacion_actividad.length;
                  index++
                ) {
                  if (change.doc.id == this.informacion_actividad[index].id) {
                    this.informacion_actividad.splice(index, 1);
                  }
                }
                this.informacion_actividad.unshift({
                  id: `${change.doc.id}`,
                  actividad: `${change.doc.data().a_nuevo_actividad}`,
                  registrado_por: `${change.doc.data().a_registrado_por}`,
                });
              } else if (change.type === "removed") {
                for (
                  let index = 0;
                  index < this.informacion_actividad.length;
                  index++
                ) {
                  if (change.doc.id == this.informacion_actividad[index].id) {
                    this.informacion_actividad.splice(index, 1);
                  }
                }
              } else {
              }
              // DEVOLVER SOLO DATOS ÚNICOS, NO REPETIDOS
              let set = new Set(this.informacion_actividad.map(JSON.stringify));
              this.informacion_actividad = Array.from(set).map(JSON.parse);
            });
          });
      }
    },

    // FUNCIÓN PARA MOSTRAR TABLA DESCRIPCIÓN
    tabla_id_actividad() {
      NProgress.start();
      db.collection("nuevo_actividad").onSnapshot((snapshot) => {
        // LIMPIAR ARRAY ANTES DE CONSULTAR
        let changes = snapshot.docChanges();
        changes.forEach((change) => {
          if (change.type === "added") {
            this.tabla_tareas(
              `${change.doc.id}`,
              `${change.doc.data().a_nuevo_actividad}`
            );
          } else if (change.type === "modified") {
            this.tabla_tareas(
              `${change.doc.id}`,
              `${change.doc.data().a_nuevo_actividad}`
            );
          } else if (change.type === "removed") {
            this.tabla_tareas(
              `${change.doc.id}`,
              `${change.doc.data().a_nuevo_actividad}`
            );
          }
        });
      });
    },

    // TABLA TAREAS
    tabla_tareas(id_actividad, actividades) {
      if (this.informacion_tarea.length > 0) {
      } else {
        this.informacion_tarea = [];
        db.collection("nuevo_tareas")
          .where("t_id_actividad", "==", id_actividad)
          .orderBy("t_fecha_registro", "desc")
          .onSnapshot((snapshot) => {
            let change = snapshot.docChanges();
            change.forEach((change) => {
              if (change.type === "added") {
                this.informacion_tarea.unshift({
                  id: `${change.doc.id}`,
                  tareas: `${change.doc.data().t_nuevo_tareas}`,
                  id_acti: `${change.doc.data().t_id_actividad}`,
                  actividades: actividades,
                  registrado_por: `${change.doc.data().t_registrado_por}`,
                });
              } else if (change.type === "modified") {
                for (
                  let index = 0;
                  index < this.informacion_tarea.length;
                  index++
                ) {
                  if (change.doc.id == this.informacion_tarea[index].id) {
                    this.informacion_tarea.splice(index, 1);
                  }
                }
                this.informacion_tarea.unshift({
                  id: `${change.doc.id}`,
                  tareas: `${change.doc.data().t_nuevo_tareas}`,
                  id_acti: `${change.doc.data().t_id_actividad}`,
                  actividades: actividades,
                  registrado_por: `${change.doc.data().t_registrado_por}`,
                });
              } else if (change.type === "removed") {
                for (
                  let index = 0;
                  index < this.informacion_tarea.length;
                  index++
                ) {
                  if (change.doc.id == this.informacion_tarea[index].id) {
                    this.informacion_tarea.splice(index, 1);
                  }
                }
              } else {
              }
              // DEVOLVER SOLO DATOS ÚNICOS, NO REPETIDOS
              let set = new Set(this.informacion_tarea.map(JSON.stringify));
              this.informacion_tarea = Array.from(set).map(JSON.parse);
            });
          });
      }
    },

    // FUNCIÓN PARA AGREGAR A LA BASE DE DATOS PROCESO
    agregar_proceso() {
      if (this.proceso == "") {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Recuerde que todos los campos son obligatorios.",
          showConfirmButton: false,
          timer: 2500,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } else {
        NProgress.start();
        var n = new Date();
        // AÑO
        var y = n.getFullYear();
        // MES
        var m = n.getMonth() + 1;
        // DÍA
        var d = n.getDate();
        // SE ORDENA AL GUSTO
        this.fecha = d + "/" + m + "/" + y;

        // HORAS
        var horas = n.getHours();
        // MINUTOS
        var minutos = n.getMinutes();
        // SEGUNDOS
        var segundos = n.getSeconds();
        // VARIABLE QUE LO ALMACENA
        this.hora_actual = horas + ":" + minutos + ":" + segundos;

        // AGREGAR UN SEGUNDO DOCUMENTO CON UN ID GENERADO
        let newClienteRef = db.collection("nuevo_proceso").doc();
        let id = newClienteRef.id;
        db.collection("nuevo_proceso")
          .doc(id)
          .set({
            p_nuevo_proceso: this.proceso,
            p_fecha_registro: this.fecha,
            p_hora_registro: this.hora_actual,
            p_registrado_por: this.$store.state.email,
          })
          .then(() => {})
          .catch((error) => {
            console.error("Error al guardar... ", error);
          });
        NProgress.done();
        NProgress.remove();
        this.proceso = "";
        $("#agregarproceso").modal("hide");
      }
    },

    // FUNCIÓN PARA AGREGAR A LA BASE DE DATOS ZONA
    agregar_zona() {
      if (this.zona == "") {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Recuerde que todos los campos son obligatorios.",
          showConfirmButton: false,
          timer: 2500,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } else {
        NProgress.start();
        var n = new Date();
        // AÑO
        var y = n.getFullYear();
        // MES
        var m = n.getMonth() + 1;
        // DÍA
        var d = n.getDate();
        // SE ORDENA A GUSTO
        this.fecha = d + "/" + m + "/" + y;

        // HORAS
        var horas = n.getHours();
        // MINUTOS
        var minutos = n.getMinutes();
        // SEGUNDOS
        var segundos = n.getSeconds();
        // VARIABLE QUE LO ALMACENA
        this.hora_actual = horas + ":" + minutos + ":" + segundos;

        // AGREGAR UN SEGUNDO DOCUMENTO CON UN ID GENERADO
        let newClienteRef = db.collection("nuevo_zona").doc();
        let id = newClienteRef.id;
        db.collection("nuevo_zona")
          .doc(id)
          .set({
            z_nuevo_zona: this.zona,
            z_fecha_registro: this.fecha,
            z_hora_registrp: this.hora_actual,
            z_registrado_por: this.$store.state.email,
          })
          .then(() => {})
          .catch((error) => {});
        NProgress.done();
        NProgress.remove();
        this.zona = "";
      }
    },

    // FUNCIÓN PARA AGREGAR A LA BASE DE DATOS ACTIVIDAD
    agregar_actividad() {
      if (this.actividad == "") {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Recuerde que todos los campos son obligatorios.",
          showConfirmButton: false,
          timer: 2500,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } else {
        NProgress.start();
        var n = new Date();
        // AÑO
        var y = n.getFullYear();
        // MES
        var m = n.getMonth() + 1;
        // DÍA
        var d = n.getDate();
        // SE ORDENA A GUSTO
        this.fecha = d + "/" + m + "/" + y;

        // HORAS
        var horas = n.getHours();
        // MINUTOS
        var minutos = n.getMinutes();
        // SEGUNDOS
        var segundos = n.getSeconds();
        // VARIABLE QUE LO ALMACENA
        this.hora_actual = horas + ":" + minutos + ":" + segundos;

        // AGREGAR UN SEGUNDO DOCUMENTO CON UN ID GENERADO
        let newClienteRef = db.collection("nuevo_actividad").doc();
        let id = newClienteRef.id;
        db.collection("nuevo_actividad")
          .doc(id)
          .set({
            a_nuevo_actividad: this.actividad,
            a_fecha_registro: this.fecha,
            a_hora_registro: this.hora_actual,
            a_registrado_por: this.$store.state.email,
          })
          .then(() => {})
          .catch((error) => {
            console.log(error);
          });
        NProgress.done();
        NProgress.remove();
        this.actividad = "";
      }
    },

    // FUNCIÓN PARA AGREGAR A LA BASE DE DATOS TAREAS
    agregar_tareas() {
      if (this.tareas == "") {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Recuerde que todos los campos son obligatorios.",
          showConfirmButton: false,
          timer: 2500,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } else {
        NProgress.start();
        var n = new Date();
        // AÑO
        var y = n.getFullYear();
        // MES
        var m = n.getMonth() + 1;
        // DÍA
        var d = n.getDate();
        // SE ORDENA A GUSTO
        this.fecha = d + "/" + m + "/" + y;

        // HORAS
        var horas = n.getHours();
        // MINUTOS
        var minutos = n.getMinutes();
        // SEGUNDOS
        var segundos = n.getSeconds();
        // VARIABLE QUE LO ALMACENA
        this.hora_actual = horas + ":" + minutos + ":" + segundos;

        // AGREGAR UN SEGUNDO DOCUMENTO CON UN ID GENERADO
        let newClienteRef = db.collection("nuevo_tareas").doc();
        let id = newClienteRef.id;
        db.collection("nuevo_tareas")
          .doc(id)
          .set({
            t_nuevo_tareas: this.tareas,
            t_id_actividad: this.actividades_id,
            t_fecha_registro: this.fecha,
            t_hora_registro: this.hora_actual,
            t_registrado_por: this.$store.state.email,
          })
          .then(() => {})
          .catch((error) => {
            console.log(error);
          });
        NProgress.done();
        NProgress.remove();
        // FIN ALERTA GUARDANDO
        this.tareas = "";
        this.actividades_id = "";
      }
    },

    // FUNCIÓN PARA MOSTRAR DATOS PROCESO
    consultar_proceso(id_proceso) {
      NProgress.start();
      let docRef = db.collection("nuevo_proceso").doc(id_proceso);
      docRef.get().then((doc) => {
        if (doc.exists) {
          this.con_key = `${doc.id}`;
          this.con_proceso = `${doc.data().p_nuevo_proceso}`;
          this.con_registrado = `${doc.data().p_registrado_por}`;
          this.con_fecha = `${doc.data().p_fecha_registro}`;
          this.con_hora = `${doc.data().p_hora_registro}`;
        }
      });
      $("#editarproceso").modal("show");
      NProgress.done();
      NProgress.remove();
    },

    // FUNCIÓN PARA MOSTRAR DATOS ZONA
    consultar_zona(id_zona) {
      NProgress.start();
      let docRef = db.collection("nuevo_zona").doc(id_zona);
      docRef.get().then((doc) => {
        if (doc.exists) {
          this.con_key = `${doc.id}`;
          this.con_zona = `${doc.data().z_nuevo_zona}`;
          this.con_fecha = `${doc.data().z_fecha_registro}`;
          this.con_hora = `${doc.data().z_hora_registrp}`;
          this.con_registrado = `${doc.data().z_registrado_por}`;
        }
      });
      NProgress.done();
      NProgress.remove();
    },

    // FUNCIÓN PARA MOSTRAR DATOS ACTIVIDAD
    consultar_actividad(id_actividad) {
      NProgress.start();
      let docRef = db.collection("nuevo_actividad").doc(id_actividad);
      docRef.get().then((doc) => {
        if (doc.exists) {
          this.con_key = `${doc.id}`;
          this.con_actividad = `${doc.data().a_nuevo_actividad}`;
          this.con_fecha = `${doc.data().a_fecha_registro}`;
          this.con_hora = `${doc.data().a_hora_registro}`;
          this.con_registrado = `${doc.data().a_registrado_por}`;
        }
      });
      NProgress.done();
      NProgress.remove();
    },

    // FUNCIÓN PARA MOSTRAR DATOS TAREAS
    consultar_tareas(id_tareas, id_acti) {
      NProgress.start();
      let docRef1 = db.collection("nuevo_actividad").doc(id_acti);
      let docRef2 = db.collection("nuevo_tareas").doc(id_tareas);

      docRef1.get().then((doc) => {
        if (doc.exists) {
          this.c_key_acti = `${doc.id}`;
          this.c_acti = `${doc.data().a_nuevo_actividad}`;
        }
      });

      docRef2.get().then((doc) => {
        if (doc.exists) {
          this.con_key = `${doc.id}`;
          this.con_tareas = `${doc.data().t_nuevo_tareas}`;
          this.con_acti = this.c_acti;
          this.con_fecha = `${doc.data().t_fecha_registro}`;
          this.con_hora = `${doc.data().t_hora_registro}`;
          this.con_registrado = `${doc.data().t_registrado_por}`;
        }
      });
      NProgress.done();
      NProgress.remove();
    },

    // VACIAR VARIABLES
    vaciar_variables_proceso() {
      $("#editarproceso").modal("hide");
      this.con_key = "";
      this.con_proceso = "";
      this.con_registrado = "";
    },

    // FUNCIÓN PARA EDITAR PROCESO
    editar_proceso(key) {
      if (this.con_proceso == "") {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Recuerde que todos los campos son obligatorios.",
          showConfirmButton: false,
          timer: 2500,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } else {
        NProgress.start();
        // FUNCIÓN PARA EDITAR
        db.collection("nuevo_proceso")
          .doc(key)
          .set({
            p_nuevo_proceso: this.con_proceso,
            p_fecha_registro: this.con_fecha,
            p_hora_registro: this.con_hora,
            p_registrado_por: this.$store.state.email,
          })
          .then(() => {})
          .catch((error) => {
            console.log(error);
          });
        $("#editarproceso").modal("hide");
        this.con_proceso = "";
        NProgress.done();
        NProgress.remove();
      }
    },

    // FUNCIÓN PARA EDITAR ZONA
    editar_zona(key) {
      if (this.con_zona == "") {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Recuerde que todos los campos son obligatorios.",
          showConfirmButton: false,
          timer: 2500,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } else {
        NProgress.start();
        // FUNCIÓN PARA EDITAR
        db.collection("nuevo_zona")
          .doc(key)
          .set({
            z_nuevo_zona: this.con_zona,
            z_fecha_registro: this.con_fecha,
            z_hora_registrp: this.con_hora,
            z_registrado_por: this.$store.state.email,
          })
          .then(() => {})
          .catch((error) => {});
        NProgress.done();
        NProgress.remove();
        this.con_zona = "";
      }
    },

    // FUNCIÓN PARA EDITAR ACTIVIDAD
    editar_actividad(key) {
      if (this.con_actividad == "") {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Recuerde que todos los campos son obligatorios.",
          showConfirmButton: false,
          timer: 2500,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } else {
        NProgress.start();
        // FUNCIÓN PARA EDITAR
        db.collection("nuevo_actividad")
          .doc(key)
          .set({
            a_nuevo_actividad: this.con_actividad,
            a_hora_registro: this.con_fecha,
            a_fecha_registro: this.con_hora,
            a_registrado_por: this.$store.state.email,
          })
          .then(() => {})
          .catch((error) => {});
        NProgress.done();
        NProgress.remove();
        this.con_actividad = "";
      }
    },

    // FUNCIÓN PARA EDITAR DESCRIPCIÓN
    id_acti_editar(con_key) {
      NProgress.start();
      db.collection("nuevo_actividad")
        .where("a_nuevo_actividad", "==", this.con_acti)
        .onSnapshot((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.editar_tareas(con_key, doc.id);
          });
        });
    },

    // FUNCIÓN PARA EDITAR TAREAS
    editar_tareas(key, key_acti) {
      if (this.con_tareas == "") {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Recuerde que todos los campos son obligatorios.",
          showConfirmButton: false,
          timer: 2500,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } else {
        // FUNCIÓN PARA EDITAR
        db.collection("nuevo_tareas")
          .doc(key)
          .set({
            t_nuevo_tareas: this.con_tareas,
            t_id_actividad: key_acti,
            t_fecha_registro: this.con_fecha,
            t_hora_registro: this.con_hora,
            t_registrado_por: this.$store.state.email,
          })
          .then(() => {})
          .catch((error) => {
            console.log(error);
          });
        NProgress.done();
        NProgress.remove();
        this.con_tareas = "";
      }
    },

    // ELIMINAR PROCESO
    eliminar_proceso(id_proceso) {
      db.collection("nuevo_proceso")
        .doc(id_proceso)
        .delete()
        .then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Proceso eliminado satisfactoriamente.",
            showConfirmButton: false,
            timer: 1500,
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
        });
    },

    // ELIMINAR ZONA
    eliminar_zona(id_proceso) {
      db.collection("nuevo_zona")
        .doc(id_proceso)
        .delete()
        .then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Zona eliminada satisfactoriamente.",
            showConfirmButton: false,
            timer: 1500,
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
        });
    },

    // ELIMINAR ACTIVIDAD
    eliminar_actividad(id_actividad) {
      db.collection("nuevo_actividad")
        .doc(id_actividad)
        .delete()
        .then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Actividad eliminada satisfactoriamente.",
            showConfirmButton: false,
            timer: 1500,
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
        });
    },

    // ELIMINAR TAREAS
    eliminar_tareas(id_tareas) {
      db.collection("nuevo_tareas")
        .doc(id_tareas)
        .delete()
        .then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Tarea eliminada satisfactoriamente.",
            showConfirmButton: false,
            timer: 1500,
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
        });
    },
  },
};
</script>
<style scoped>
.titulo {
  color: #878787;
  font-size: 30px;
  text-align: left;
}
</style>
